import { useState } from "react";

import loading from '../loading.webp'

function BarBottom(props) {


    const[progress, setProgress] = useState(props.progress);




    if(props.progress != progress)
    {
        setProgress(props.progress);
    }

    var vSyleWidth =  "0%";
    var vCenter = null;


    if(progress > 0 <= 100) 
    {
      vSyleWidth = progress+"%"; //procent ładowania..
    }

    if(progress == -1) 
    {
       vSyleWidth = "0%";      //stop ładowania..
    }

    if(progress == -2) 
    {
        vSyleWidth = "90%";      //animacja ładowania..

        vCenter = <div className="progress_bar_center">
                <img src={loading}/>
        </div>
    }

    return (
        <div className="bottom_bar ">
                        <div className="bottom_bar_pr" style={{width: vSyleWidth}}>
                            &nbps;
                        </div>
                        {vCenter}
                   </div>
    )
}



export default BarBottom;

